import State from "../../State";

export default class StateSave {
    constructor() {        
    }

    /**
     * @param {State} state 
     * @returns {Object}
     */
    static generateSave(state) {
        const saveState = {};

        saveState.v = 1;  // save version

        saveState.seed = state.worldSeed;

        return saveState;
    }

    /**
     * @param {State} state 
     * @param {Object} saveState 
     */
    static loadSave(state, saveState) {
        if (!saveState) {
            return;
        }

        state.worldSeed = saveState.seed;
    }
}